var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoaderActive)?_c('div',{staticClass:"loader-overlay"},[_c('img',{staticClass:"loader-logo",attrs:{"src":require("@/assets/images/intranort-logo.png"),"alt":"Loader"}}),_c('div',{staticClass:"loader"})]):_vm._e(),_c('div',{class:{ 'blur-content': _vm.isLoaderActive }},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }